import { MutationTree } from 'vuex';
import store from '../store';
import { Error } from '../types';
import { Firmware, FirmwareState } from './types';

export const mutations: MutationTree<FirmwareState> = {
  GET_SUCCESS: (state, payload: Firmware) => {
    state.firmware = payload;
  },
  GET_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'FIRMWARE_GET_ERROR_',
      error: payload.status,
    });
  },
  UPLOAD_FIRMWARE_SUCCESS: (state) => {
    store.commit('alert/SHOW', { success: 'UPLOAD_FIRMWARE_SUCCESS' });
  },
  UPLOAD_FIRMWARE_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'UPLOAD_FIRMWARE_ERROR_',
      error: payload.status,
    });
  },
};
